// Core React
import React from 'react';
import { connect } from 'react-redux'

// CSS
import './Block.css';

class BlockBorder extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (this.props.collage.borderWidth != nextProps.collage.borderWidth 
      || this.props.collage.backgroundColor != nextProps.collage.backgroundColor 
      || nextProps.photo.gandr_size.width != this.props.photo.gandr_size.width
      || nextProps.photo.gandr_size.height != this.props.photo.gandr_size.height
      || nextProps.photo.gandr_pos.x != this.props.photo.gandr_pos.x
      || nextProps.photo.gandr_pos.y != this.props.photo.gandr_pos.y
    );
  }

  render() {

    // let className = 'IconOption ButtonReset' + (this.props.highlight ? ' IconOption--Highlight' : '');
    
    const borderSizes = {
      left: this.props.photo.gandr_pos.x == 0 ? (this.props.collage.borderWidth * 2) : this.props.collage.borderWidth,
      top: this.props.photo.gandr_pos.y == 0 ? (this.props.collage.borderWidth * 2) : this.props.collage.borderWidth,
      right: (this.props.photo.gandr_pos.x + this.props.photo.gandr_size.width) >= this.props.collage.resolution.width ? (this.props.collage.borderWidth * 2) : this.props.collage.borderWidth,
      bottom: (this.props.photo.gandr_pos.y + this.props.photo.gandr_size.height) >= this.props.collage.resolution.height ? (this.props.collage.borderWidth * 2) : this.props.collage.borderWidth
    };

    return (
      <div className="BlockerBorders">
        <div className={'BlockBorder BlockBorder--Top'} aria-hidden="true" style={{height: borderSizes.top, backgroundColor: this.props.collage.backgroundColor}}></div>
        <div className={'BlockBorder BlockBorder--Right'} aria-hidden="true" style={{width: borderSizes.right, backgroundColor: this.props.collage.backgroundColor}}></div>
        <div className={'BlockBorder BlockBorder--Bottom'} aria-hidden="true" style={{height: borderSizes.bottom, backgroundColor: this.props.collage.backgroundColor}}></div>
        <div className={'BlockBorder BlockBorder--Left'} aria-hidden="true" style={{width: borderSizes.left, backgroundColor: this.props.collage.backgroundColor}}></div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  null
)(BlockBorder)
